import apiUrls from './urls';
import actions from './actions/actions';


export default function idleMonitor (store) {
    return (next) => {
        const idleState = { watching: false, timeoutRef: null };

        return (action) => {
            switch (action.type) {
            case actions.USER_DATA_LOADED:
                idleState.watching = true;
                break;
            case actions.LOGOUT_USER:
                idleState.watching = false;
            }

            if (idleState.timeoutRef) {
                clearTimeout(idleState.timeoutRef);
            }

            if (idleState.watching) {
                idleState.timeoutRef = setTimeout(
                    // () => (window.location = apiUrls.LOGOUT),
                    () => { console.info("user is now idle and should be signed out") },
                    process.env.IDLE_TIMEOUT
                );
            }

            next(action);
        };
    };
}



// WEBPACK FOOTER //
// ./app/idleMonitor.js